import ElementWistiaVideo from './ElementWistiaVideo';

export default ElementWistiaVideo;
export * from './ElementWistiaVideo';
